function facetsPriceRange() {
  // Bandera para prevenir bucles de sincronización
  let isUpdating = false

  // Función para actualizar el relleno del slider
  function updateSliderFill(container) {
    const minInput = container.querySelector(".field__input-price-min")
    const maxInput = container.querySelector(".field__input-price-max")
    const fillElement = container.querySelector(".range-fill")

    if (!minInput || !maxInput || !fillElement) return

    const min = parseInt(minInput.min)
    const max = parseInt(minInput.max) // Usar el max consistente de cualquier input
    let minVal = parseInt(minInput.value)
    let maxVal = parseInt(maxInput.value)

    // Validar que el mínimo no sea mayor que el máximo
    if (minVal > maxVal) {
      minVal = maxVal
      minInput.value = minVal
    }

    // Validar que el máximo no sea menor que el mínimo
    if (maxVal < minVal) {
      maxVal = minVal
      maxInput.value = maxVal
    }

    const range = max - min
    const minProgress = (minVal - min) / range
    const maxProgress = (maxVal - min) / range

    // Cálculo simple - CSS translateX(-50%) en thumbs maneja el centrado
    const minPercent = minProgress * 100
    const maxPercent = maxProgress * 100
    const widthPercent = maxPercent - minPercent

    // Validar que los cálculos son correctos
    if (isNaN(minPercent) || isNaN(maxPercent) || isNaN(widthPercent)) {
      return
    }

    // Actualizar directamente el elemento de relleno
    fillElement.style.left = minPercent + "%"
    fillElement.style.width = widthPercent + "%"
  }

  // Función para ajustar el ancho del input basándose en el contenido
  function adjustInputWidth(input) {
    const value = input.value.toString()
    const charCount = value.length
    const newWidth = Math.max(1, Math.min(charCount, 3)) + 'ch'
    input.style.width = newWidth
  }

  const rangeInput = document.querySelectorAll(".js-price-range .range-input input")

  rangeInput.forEach((input) => {
    input.addEventListener("input", (e) => {
      const container = e.target.closest(".facets__price")
      updateSliderFill(container)
    })
  })

  const rangeInputMobile = document.querySelectorAll(".js-price-range-mobile .range-input input")

  rangeInputMobile.forEach((input) => {
    // Evento cuando se mueve el slider
    input.addEventListener("input", (e) => {
      if (isUpdating) return // Prevenir bucles

      isUpdating = true

      const container = e.target.closest(".facets__price")
      updateSliderFill(container)

      // Sincronizar con campos de texto
      const wrapper = e.target.closest(".mobile-facets__price-wrapper")
      if (wrapper) {
        const isMin = e.target.classList.contains("field__input-price-min")
        const textInput = wrapper.querySelector(isMin ? ".price-min-text" : ".price-max-text")

        if (textInput) {
          let value = parseInt(e.target.value)

          // Validación adicional para mantener coherencia min/max
          if (isMin) {
            const maxInput = wrapper.querySelector(".field__input-price-max")
            const maxValue = parseInt(maxInput.value)
            if (value > maxValue) {
              value = maxValue
              e.target.value = value
            }
          } else {
            const minInput = wrapper.querySelector(".field__input-price-min")
            const minValue = parseInt(minInput.value)
            if (value < minValue) {
              value = minValue
              e.target.value = value
            }
          }

          textInput.value = value

          // Agregar clase active mientras se mueve el slider
          textInput.classList.add("active")

          // Ajustar el ancho del input basándose en el contenido
          adjustInputWidth(textInput)
        }
      }

      setTimeout(() => {
        isUpdating = false
      }, 10) // Reset después de un momento
    })

    // Evento cuando se presiona el mouse sobre el slider
    input.addEventListener("mousedown", (e) => {
      const wrapper = e.target.closest(".mobile-facets__price-wrapper")
      if (wrapper) {
        const isMin = e.target.classList.contains("field__input-price-min")
        const textInput = wrapper.querySelector(isMin ? ".price-min-text" : ".price-max-text")
        if (textInput) {
          textInput.classList.add("active")
        }
      }
    })

    // Evento cuando se suelta el mouse del slider
    input.addEventListener("mouseup", (e) => {
      const wrapper = e.target.closest(".mobile-facets__price-wrapper")
      if (wrapper) {
        const isMin = e.target.classList.contains("field__input-price-min")
        const textInput = wrapper.querySelector(isMin ? ".price-min-text" : ".price-max-text")
        if (textInput) {
          textInput.classList.remove("active")
        }
      }
    })

    // Evento cuando se pierde el foco del slider
    input.addEventListener("blur", (e) => {
      const wrapper = e.target.closest(".mobile-facets__price-wrapper")
      if (wrapper) {
        const isMin = e.target.classList.contains("field__input-price-min")
        const textInput = wrapper.querySelector(isMin ? ".price-min-text" : ".price-max-text")
        if (textInput) {
          textInput.classList.remove("active")
        }
      }
    })
  })

  // Sincronización bidireccional: campos de texto ↔ sliders
  const textInputs = document.querySelectorAll(".js-price-range-mobile .price-text-input")

  textInputs.forEach((textInput) => {
    textInput.addEventListener("input", (e) => {
      if (isUpdating) return // Prevenir bucles

      const container = e.target.closest(".mobile-facets__price-wrapper")
      if (!container) return

      isUpdating = true

      const isMin = e.target.classList.contains("price-min-text")
      const rangeInput = container.querySelector(isMin ? ".field__input-price-min" : ".field__input-price-max")

      if (rangeInput) {
        // Asegurar que sea un número entero
        let intValue = parseInt(e.target.value) || 0

        // Validación para mantener coherencia min/max
        if (isMin) {
          const maxInput = container.querySelector(".field__input-price-max")
          const maxValue = parseInt(maxInput.value)
          if (intValue > maxValue) {
            intValue = maxValue
          }
        } else {
          const minInput = container.querySelector(".field__input-price-min")
          const minValue = parseInt(minInput.value)
          if (intValue < minValue) {
            intValue = minValue
          }
        }

        e.target.value = intValue // Actualizar el campo de texto sin decimales

        // Actualizar el valor del slider correspondiente
        rangeInput.value = intValue

        // Actualizar el relleno
        const priceRange = container.querySelector(".facets__price")
        if (priceRange) {
          updateSliderFill(priceRange)
        }

        // Ajustar el ancho del input basándose en el contenido
        adjustInputWidth(e.target)
      }

      setTimeout(() => {
        isUpdating = false
      }, 10) // Reset después de un momento
    })
  })

  // Inicializar todos los sliders al cargar la página con un pequeño delay
  const priceContainers = document.querySelectorAll(".js-price-range-mobile .facets__price")
  priceContainers.forEach((container) => {
    // Usar timeout para asegurar que los elementos estén completamente renderizados
    setTimeout(() => {
      updateSliderFill(container)

      // Ajustar el ancho inicial de los inputs de texto
      const wrapper = container.closest(".mobile-facets__price-wrapper")
      if (wrapper) {
        const minTextInput = wrapper.querySelector(".price-min-text")
        const maxTextInput = wrapper.querySelector(".price-max-text")
        if (minTextInput) adjustInputWidth(minTextInput)
        if (maxTextInput) adjustInputWidth(maxTextInput)
      }
    }, 100)
  })
}

facetsPriceRange()
